import React, { FC } from "react";

import {
  useApisMembersDirectMessagesLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeeType } from "~/domains";

import { ReactedEmployeesModal } from "~/ui";

type PropsType = {
  directMessageId: string;
  onClose: () => void;
};

export const DirectMessageLikedEmployeesModal: FC<PropsType> = ({
  directMessageId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersDirectMessagesLikedEmployeesIndex({
      directMessageId,
      config: {
        onSuccess: (data) => {
          setItems(data.pages.map((page) => page.directMessageLikes).flat());
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
